import React, { forwardRef, useCallback } from 'react';
import cn from 'classnames';
import Button from 'components/Button';
import { config } from 'utils/config';
import utils from '@ehi/global-marketing-interface/utils';

const CustomInput = forwardRef((props, ref) => {
  const {
    className,
    disabled,
    name,
    value,
    setCustomInputRef,
    datePickerRef,
    label,
    selectedProp,
    asterisk,
    onInputClick,
    onClick,
    ...rest
  } = props;

  const handleClick = useCallback(() => {
    onInputClick();
    onClick();
  }, [onInputClick, onClick]);

  const displayValue = value
    ? utils.getDateTimeObjFromTs(value, ['YYYY-MM-DD']).format(config.getDateTimeShortFormat('day_date_month'))
    : '';

  const ariaLabel = label;
  const asteriskValue = asterisk ? 'required' : displayValue;
  const displayedValueString = displayValue.length > 0 ? displayValue : asteriskValue;

  const datePickerOpen = datePickerRef?.state?.open;
  const ariaExpanded = typeof datePickerOpen === 'undefined' ? false : datePickerOpen;
  const selectionMade = selectedProp !== null;

  const requiredAriaLabel = `${ariaLabel} ${displayedValueString}`;

  return (
    <div ref={ref}>
      <Button
        plain
        {...rest}
        onClick={handleClick}
        disabled={disabled}
        type='button'
        className={cn(className, 'field-button', 'dropdown', { 'aria-expanded': ariaExpanded })}
        name={name}
        buttonRef={setCustomInputRef}
        // AWR-6654 - Accessibility - The aria-expanded and aria-live attributes are incorrect and should be removed.
        // The aria-expanded attribute will be reported to assistive technology users as a disclosure button, when it isn't a disclosure button.
        // aria-live='polite'
        // aria-expanded={ariaExpanded}
        aria-label={requiredAriaLabel}
        aria-pressed={selectionMade}
      >
        {displayValue}
      </Button>
    </div>
  );
});

export default CustomInput;
